module.exports = __webpack_public_path__ + "static/media/browOuterUpRight.f803e3de.obj";